import {Injectable} from '@angular/core';
import {HttpService} from '../../../services/http.service';

@Injectable()

export class RemarkService {

    constructor(private httpService: HttpService) {

    }

    getPositions() {
        return this.httpService.get(`api/remark/get-position`);
    }
}
